import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {TaskStatusType} from "../types/taskFlow.types";


type IMyEditableShape = TLBaseShape<
    'step-label-shape',
    {
        index: number,
        text: string,
        status: string,
        h: number,
        w: number
    }
>

export class StepLabelShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'step-label-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        index: T.number,
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            index: 1,
            text: '',
            status: '待确认',
            w: 360,
            h: 50,
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }
    
    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        return (
            <HTMLContainer
                id={shape.id}
                // [b]
                onPointerDown={isEditing ? stopEventPropagation : undefined}
                style={{
                    pointerEvents: isEditing ? 'all' : 'none',
                    backgroundColor: '#E3F0FF',
                    fontSize: 14,
                    padding: 16,
                    borderRadius: 20,
                    color: '#444444'
                }}
            >
                <div style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
                    <div style={{background: '#007AFF', color: 'white', fontSize: 12, borderRadius: 10, padding: 3, height: 18, width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
                        {shape.props.index}
                    </div>
                    <div style={{fontWeight: "bold", maxWidth: 950, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{shape.props.text}</div>
                    <div style={{color: '#007AFF'}}>{shape.props.status}</div>
                </div>
            </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}